// extracted by mini-css-extract-plugin
export default {"tooltip":"_W-z","arrow":"aX-z"};